import type { ReactNode } from "react";
import { RequirePermission } from "@its-engineering-and-development/rbac-react";
import { NotAuthorizedState } from "@app/components/auth-guard/not-authorized-state";

type PermissionGuardProps = {
  action: string;
  children: ReactNode;
  fallback?: ReactNode;
};

const defaultLoading = (
  <section className="events-page">
    <p>Loading permissions…</p>
  </section>
);

const defaultFallback = <NotAuthorizedState />;

export function PermissionGuard({
  action,
  children,
  fallback = defaultFallback,
}: PermissionGuardProps) {
  return (
    <RequirePermission
      action={action}
      fallback={fallback}
      loading={defaultLoading}
    >
      {children}
    </RequirePermission>
  );
}
